<template>
  <div ref="rootRef" class="collage-carousel">
        <div class="rasgado rasgado-top"></div>
<br><br>
    <!-- FONDO ROSA -->
    <div ref="bgRef" class="bg-rosa"></div>

    <!-- 🌸 FLORES Y ORNAMENTOS EN ORILLAS -->
    <img src="@/assets/monio.png" class="flor flor-lt render-gpu" alt="Ornamento" />
    <img src="@/assets/monio.png" class="flor flor-lb render-gpu" alt="Ornamento" />
    <img src="@/assets/monio.png" class="flor flor-rt render-gpu" alt="Ornamento" />
    <img src="@/assets/monio.png" class="flor flor-rb render-gpu" alt="Ornamento" />

    <!-- CONTENEDOR DE VIDEO EDITORIAL -->
    <div class="collage-grid">
      <div
        ref="videoContainerRef"
        class="collage-item render-gpu"
        @click="openModal"
      >
        <video
          ref="videoRef"
          class="collage-video"
          src="@/assets/video2.mp4"
          autoplay
          loop
          muted
          playsinline
          webkit-playsinline
          preload="auto"
        ></video>
      </div>
    </div>

    <!-- MODAL DE VIDEO AMPLIADO -->
    <div
      v-if="isVideoEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <video
        class="enlarged-video"
        src="@/assets/video1.mp4"
        autoplay
        loop
        muted
        playsinline
        webkit-playsinline
      ></video>
    </div>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimadoMagico',
  setup() {
    const rootRef = ref(null)
    const bgRef = ref(null)
    const videoRef = ref(null)
    const videoContainerRef = ref(null)
    const isVideoEnlarged = ref(false)

    let observer = null

    // Forzar reproducción de video ante cualquier interacción en pantalla (Mobile Autoplay Unblock)
    const handleUserInteraction = () => {
      if (videoRef.value && videoRef.value.paused) {
        videoRef.value.play().catch(() => {})
      }
    }

    const openModal = () => {
      isVideoEnlarged.value = true
    }

    const closeModal = () => {
      isVideoEnlarged.value = false
    }

    onMounted(async () => {
      await nextTick()

      // Habilitar escucha global de toque/clic para garantizar Autoplay en celulares
      window.addEventListener('touchstart', handleUserInteraction, { once: true, passive: true })
      window.addEventListener('click', handleUserInteraction, { once: true, passive: true })

      gsap.config({ force3D: true })

      const flores = rootRef.value.querySelectorAll('.flor')

      // Estados iniciales ultra ligeros para GPU
      gsap.set(bgRef.value, { autoAlpha: 0 })
      gsap.set(flores, { autoAlpha: 0, scale: 0.9, y: 8 })
      gsap.set(videoContainerRef.value, { autoAlpha: 0, scale: 0.96, y: 15 })

      // Observador de pantalla de respuesta rápida
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          // Intentar reproducir video inmediatamente
          handleUserInteraction()

          const tl = gsap.timeline({ defaults: { ease: 'power2.out', force3D: true } })

          // 1. Revelado instantáneo de fondo + video
          tl.to(bgRef.value, { autoAlpha: 1, duration: 0.3 })
            .to(videoContainerRef.value, {
              autoAlpha: 1,
              scale: 1,
              y: 0,
              duration: 0.5
            }, '-=0.2')

          // 2. Flores entran suavemente
          .to(flores, {
            autoAlpha: 0.95,
            scale: 1,
            y: 0,
            duration: 0.5,
            stagger: 0.05
          }, '-=0.3')

          // Desconectar observador para liberar recursos de memoria
          if (rootRef.value) observer.unobserve(rootRef.value)
        })
      }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' })

      if (rootRef.value) observer.observe(rootRef.value)
    })

    onUnmounted(() => {
      if (observer) observer.disconnect()
      window.removeEventListener('touchstart', handleUserInteraction)
      window.removeEventListener('click', handleUserInteraction)
    })

    return {
      rootRef,
      bgRef,
      videoRef,
      videoContainerRef,
      isVideoEnlarged,
      openModal,
      closeModal
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  position: relative;
  width: 100%;
  min-height: 60vh;
  margin-bottom:0px;
  overflow: visible;
}

/* FONDO ROSA */
.bg-rosa {
  position: absolute;
  inset: 0;
  background: #f0c9d3;
  z-index: 0;
  opacity: 0;
}

/* 🌸 FLORES */
.flor {
  position: absolute;
  width: 150px;
  max-width: 42vw;
  opacity: 0;
  pointer-events: none;
  z-index: 3;
}

.flor-lt { top: -2vh; left: -40px; }
.flor-lb { bottom: 5vh; left: -50px;  }
.flor-rt { top: -2vh; right: -40px;  }
.flor-rb { bottom: 5vh; right: -50px;  }

/* GRID */
.collage-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding-top: 4vh;
  padding-bottom: 4vh;
}

/* ITEM */
.collage-item {
  grid-column: span 12;
  opacity: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4vh;
}

/* VIDEO EDITORIAL */
.collage-video {
  width: 90%;
  max-width: 480px;
  height: auto;
  display: block;
  border-radius: 14px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  object-fit: cover;
  pointer-events: auto;
}

/* MODAL AMPLIADO */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background: #ffffff;
  z-index: 1;
  pointer-events: none;
}
.rasgado-top {
  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}
.enlarged-video {
  max-width: 92%;
  max-height: 85vh;
  border-radius: 12px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.6);
  object-fit: contain;
}

/* ===== RASGADO ===== */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  pointer-events: none;
}

.rasgado-inferior {
  bottom: 0;
  background: #f0c9d3;
  clip-path: polygon(
    0% 80%,
    25% 60%,
    50% 85%,
    75% 55%,
    100% 75%,
    100% 0%,
    0% 0%
  );
  z-index: 1;
}

/* Aceleración por Hardware Estricta */
.render-gpu {
  will-change: transform, opacity;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
}
</style>